module.exports = __webpack_public_path__ + "img/img3.ec061d36.jpg";